'use client'

import { Info } from 'lucide-react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            position="bottom-right"
            className="toaster group"
            icons={{
                info: <Info className="size-4" />,
            }}
            toastOptions={{
                unstyled: true,
                classNames: {
                    toast: 'group shadow-custom flex items-center gap-2 px-6 py-4 rounded-s border-border border text-[14px] w-full',
                    info: 'bg-white text-foreground',
                    success: 'bg-neotaste text-neotaste-foreground',
                    warning: 'bg-warning text-warning-foreground border-border/10',
                    error: 'bg-destructive text-destructive-foreground border-border/20',
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
